import { TableRepository } from '../../../repositories/table/table.repository';
import { URL } from '../../../integrations/url/url';
import { Locale } from '../../../integrations/locale/locale';
import { SimpleModal } from '../../../modals/simple-modal.modal';
import { Authentication } from '../../../integrations/authentication/authentication';

export class MenuComponent extends SimpleModal {
    private readonly _tableInput: JQuery<HTMLInputElement>;
    private readonly _continueBtn: JQuery<HTMLButtonElement>;
    private readonly _menuError: JQuery<HTMLElement>;
    private readonly _menuTableLoader: JQuery<HTMLElement>;
    private readonly _modalLoader: JQuery<HTMLElement>;

    private readonly _tableRepository: TableRepository;

    public constructor(container: JQuery) {
        super(container);

        this._tableInput = container.find<HTMLInputElement>('.menu__table-number');
        this._continueBtn = container.find<HTMLButtonElement>('.menu__continue_btn');
        this._menuTableLoader = $(document.body).find<HTMLButtonElement>('.page__loader');
        this._modalLoader = container.find('.loading_io_spinner');

        this._menuError = this._container.find('.menu__error');

        this._tableRepository = new TableRepository();

        this._addMenuEventListeners();

        Locale.loadTranslations().then(this._checkInfoHash.bind(this));
    }

    private _showModalLoader() {
        this._modalLoader.css('display', 'flex');
    }

    private _hideModalLoader() {
        this._modalLoader.css('display', 'none');
    }

    private _showLoader() {
        this._menuTableLoader.fadeIn(200);
    }

    private _hideLoader() {
        this._menuTableLoader.fadeOut(200);
    }

    private _showError() {
        this._menuError.show();
    }

    private _hideError() {
        this._menuError.hide();
    }

    private _checkInfoHash() {
        const info = URL.getHashValue('info');

        if (info === undefined) {
            return;
        }

        this._container.attr('data-error', info);

        const infoCard = this._container.find('.menu__error');

        let text = $.i18n(info);

        if (info === 'info_bill_paid') {
            text = Locale.getTrans('payment.paymentProcessed', info).toString();
        }

        if (info === 'error_no_open_account') {
            text = Locale.getTrans('payment.no_open_account', info).toString();
        }

        infoCard.text(text);

        infoCard.show();
    }

    private _onTableInputKeyup(e: Event) {
        const { target } = e;
        const { value } = <HTMLInputElement>target;

        this._hideError();

        if (value === '') {
            this._disabledContinueBtn();

            return;
        }

        this._enableContinueBtn();
    }

    private _disabledContinueBtn() {
        this._continueBtn.attr('disabled', 'disabled');
    }

    private _enableContinueBtn() {
        this._continueBtn.removeAttr('disabled');
    }

    private async _onContinueBtnClick() {
        this._showModalLoader();
        const inputTable = this._tableInput.val()?.toString();

        if (inputTable === undefined) {
            return;
        }

        const [locationId] = URL.getUrlData();

        try {
            const { data: { next } } = await this._tableRepository.check(locationId, inputTable);

            this._goToTable(next, inputTable);
        } catch (e) {
            this._hideModalLoader();
            this._showError();
        }
    }

    private async _goToTable(guestUrl: string, table: string) {
        const token = Authentication.getInstance().getCurrentToken();

        if (!token) {
            URL.goto(guestUrl);

            return;
        }

        const [locationId] = URL.getUrlData();
        const { data } = await this._tableRepository.getUserTable(locationId, table, token);

        URL.goto(data.url);
    }

    protected _addMenuEventListeners(): void {
        this._tableInput.on('keyup', this._onTableInputKeyup.bind(this));
        this._continueBtn.on('click', this._onContinueBtnClick.bind(this));
    }

    public async open() {
        const [locationId, tableNumber] = URL.getUrlData();

        if (tableNumber !== '') {
            try {
                this._showLoader();

                const { data: { next } } = await this._tableRepository.check(locationId, tableNumber);

                this._goToTable(next, tableNumber);

                return;
            } catch (e) {
                this._hideLoader();
                URL.goto('#info=error_no_open_account');
                this._checkInfoHash();
            }
        }

        super.open();
    }

    public close() {
        this._hideError();
        this._tableInput.val('');

        super.close();
    }
}
